import {
  FETCH_ADVANCED_SEARCH_REQUEST,
  FETCH_ADVANCED_SEARCH_SUCCESS,
  FETCH_ADVANCED_SEARCH_FAILURE,
} from "../actions/FilterActions";

const initialState = {
  results: [],
  suggestions: [],
  totalResults: 0,
  searchTerm: "",
  loading: false,
  error: null,
};

const advancedSearchReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_ADVANCED_SEARCH_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case FETCH_ADVANCED_SEARCH_SUCCESS:
      return {
        ...state,
        loading: false,
        results: action.payload.results,
        suggestions: action.payload.suggestions,
        totalResults: action.payload.totalResults,
        searchTerm: action.payload.searchTerm,
        error: null,
      };
    case FETCH_ADVANCED_SEARCH_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.error,
        results: [],
        suggestions: [],
        totalResults: 0,
      };
    default:
      return state;
  }
};

export default advancedSearchReducer;
